import {useState, useCallback} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {deleteReport, requestReportPDF} from "../../../../redux/Actions/reports.actions";

export const useReportTableActions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalOpen, toggleModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState("");

  const handleDelete = () => {
    dispatch(deleteReport(selectedReport, () => toggleModal(false)));
  };

  const handleRowClick = useCallback(
    (data) => {
      navigate(`/app/reports/${data.id}/edit-report`);
    },
    [navigate]
  );

  const handleActionSelection = useCallback(
    (action, data) => {
      switch (action) {
        case "Edit":
          navigate(`/app/reports/${data.id}/edit-report`);
          break;
        case "Review":
        case "View":
          navigate(`/app/reports/${data.id}/edit-report`);
          break;
        case "View_Charts":
          navigate(`/app/reports/${data.id}/view-charts`);
          break;
        case "Delete":
          toggleModal(true);
          setSelectedReport(data.id);
          break;
        case "Export":
          dispatch(requestReportPDF(data.id));
          break;
      }
    },
    [dispatch, navigate]
  );

  return {
    modalOpen,
    selectedReport,
    toggleModal,
    handleDelete,
    handleRowClick,
    handleActionSelection,
  };
};
